<template>
  <div :class="{'option': true, 'mobile': mobile}">
    <input type="text" spellcheck="false" maxlength="80" :value="title" @change="onChange">
  </div>
</template>

<script>
export default {
  name: 'TitleInput',
  props: {
    title: String,
    mobile: Boolean
  },
  methods: {
    onChange(event) {
      this.$emit('onChange', event.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  input {
    width: 18rem;
    height: 2.5rem;
    border: none;
    padding-left: 0.8rem;
    padding-right: 0.5rem;
    background: none;
    color: #0c776c;
    font-size: 1.2rem;
    font-weight: bold;
    border-radius: 0.2rem;
    outline: none;
    margin-left: 0.5rem;
    margin-right: 0.5rem;

    @media (max-width: 680px) {
      width: 13rem;
    }
    @media (max-width: 600px) {
      display: none;
    }
  }
}

.mobile {
  display: none;
  @media (max-width: 600px) {
    display: flex;
    width: 95vw;
    height: 3.5rem;
    input {
      width: 100%;
      height: 3rem;
      background-color: #0f978a;
      color: white;
      font-size: 1rem;
      font-weight: unset;
      margin-left: 0rem;
      margin-right: 0rem;
      @media (max-width: 680px) {
        width: 100%;
      }
      @media (max-width: 600px) {
        display: flex;
      }
      &::placeholder {
        color: rgba(255, 255, 255, 0.637);
      }
    }
  }
}
</style>